import AxiosClient from './api'
import END_POINT from './constants'

export function getAccountInfo(userId) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.ACCOUNT_INFO.GET_INFO}/${userId}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getAllCustomerRequest() {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.GET_ALL_CUSTOMER}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updateAccountInfoBasic(payload, userId) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.ACCOUNT_INFO.UPDATE_BASIC}/${userId}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updateAccountInfoBusiness(payload, userId) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.ACCOUNT_INFO.UPDATE_BUSINESS}/${userId}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
